module.exports = __webpack_public_path__ + "img/sao.8c300fd1.jpg";